import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Outstanding: {
    description: 'returnShipmentObject.Outstanding',
    defaultMessage: 'Outstanding',
    id: 'kjjRNk',
  },
  Received: {
    description: 'returnShipmentObject.Received',
    defaultMessage: 'Received',
    id: 'h8vsG4',
  },
  Voided: {
    description: 'returnShipmentObject.Voided',
    defaultMessage: 'Voided',
    id: 'QCH6Og',
  },
});

export const ReturnStatus = {
  Outstanding: {
    isCompleted: false,
    translation: messages.Outstanding,
    toString: () => 'Outstanding',
  },
  Received: {
    isCompleted: true,
    translation: messages.Received,
    toString: () => 'Received',
  },
  Voided: {
    isCompleted: false,
    translation: messages.Voided,
    toString: () => 'Voided',
  },
};
